const smallTitleText = ({ text }) => {
  return <h4 className="text-2xl font-semibold text-white">{text}</h4>;
};

export default smallTitleText;
